/**
 * Created by xiehan on 2018/11/12.
 */

import Logic from '../logic-base'

const kpiMappingBiz = new Logic()

kpiMappingBiz.getKpiMap = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.kpi.getKpiMap,
    data: data
  })
}

export default kpiMappingBiz
